module.exports = __webpack_public_path__ + "img/close.2b7ea088.svg";